<button mat-raised-button color="accent" class="create-button" [matMenuTriggerFor]="createMenu">
  <mat-icon>add</mat-icon> <span class="text" [innerHTML]="'$common_create' | translate"></span>
</button>
<mat-menu #createMenu="matMenu" xPosition="before">
  <div class="menu-header">
    {{'$create_button_create_new' | translate}}
  </div>
  <button mat-menu-item (click)="openNewTaskDialog()">{{'$common_task' | translate}}</button>
  <button mat-menu-item (click)="createNewUser()">{{'$create_button_user' | translate}}</button>
</mat-menu>
  
